import React from 'react';
import { ButtonGroup, DropdownButton, Modal, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import * as Fi from 'react-icons/fi';

import {DeliveryPlan, Table } from 'services/action';

const initialState = {
  showDelete: false,
  showTMS: false,
};

const Action = ({ data }) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state.Form);
  const StateTable = useSelector((state) => state?.Table?.data['deliveryPlan']);

  const [{ showDelete, showTMS }, setState] = React.useState(initialState);

  const $handleClose = () => {
    setState((prevState) => ({ ...prevState, showDelete: false, showTMS: false }));
  };

  const $handleDelete = async () => {
    const del = await Dispatch(DeliveryPlan.$delete(data?.id));
    if (del?.message === 'success') {
      $handleClose();
      Dispatch(Table.$reload('deliveryPlan', StateTable));
    }
  };

  const $handleSendTMS = async () => {
    const del = await Dispatch(DeliveryPlan.$sendToTMS(data?.id));
    if (del?.message === 'success') {
      $handleClose();
      Dispatch(Table.$reload('deliveryPlan', StateTable));
    }
  };

  return (
    <>
      <DropdownButton
        as={ButtonGroup}
        variant="transparent"
        size="md"
        className="no-carret tbl-action"
        title={<Fi.FiMoreVertical size={13} color="gray" />}
      >
        <Link
          className="dropdown-item d-flex align-items-center"
          role="button"
          to={`/delivery/plan/${data?.id}`}
        >
          <Fi.FiClipboard size={15} color="#202020" className="me-2" />
          Detil
        </Link>
        {!data?.is_tms && (
          <button
            className="dropdown-item d-flex align-items-center"
            onClick={() =>
              setState((prevState) => ({ ...prevState, showTMS: true }))
            }
          >
            <Fi.FiTruck size={15} className="me-2" />
            Kirim By TMS
          </button>
        )}

        {
          data?.fulfillment_status === 'unprocess' && (
            <>
              <Link
                className="dropdown-item d-flex align-items-center"
                role="button"
                to={{
                  pathname: '/delivery/fulfillment/create',
                  state: { plan: data?.id },
                }}
              >
                <Fi.FiEdit size={15} color="#202020" className="me-2" />
                Buat Fulfillment
              </Link>
              <Link
                className="dropdown-item d-flex align-items-center"
                role="button"
                to={`/delivery/plan/${data?.id}/update`}
              >
                <Fi.FiEdit size={15} color="#202020" className="me-2" />
                  Perbaharui
              </Link>
              <button
                className="dropdown-item d-flex align-items-center"
                onClick={() =>
                  setState((prevState) => ({ ...prevState, showDelete: true }))
                }
              >
                <Fi.FiTrash2 size={15} className="me-2" />
                  Hapus
              </button>
              <Link
                className="dropdown-item d-flex align-items-center"
                role="button"
                to={`/print/fulfillment/${data?.id}`}
                target="_blank"
              >
                <Fi.FiPrinter size={15} color="#202020" className="me-2" />
                Print Surat Jalan
              </Link>
            </>
          )
        }

      </DropdownButton>

      {/* modal delete */}
      <Modal
        show={showDelete}
        onHide={$handleClose}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleClose} />
          <div className="modal-status bg-danger" />
          <Fi.FiAlertTriangle className="mb-2 text-danger" size={90} />
          <h3>Anda yakin?</h3>
          <p className="text-danger fw-semibold">
            Data yang sudah dihapus tidak bisa dipulihkan
          </p>
        </Modal.Body>
        <Modal.Footer>
          <div className="row w-100">
            <div className="col">
              <Button variant="white" className="w-100" onClick={$handleClose}>
                Batal
              </Button>
            </div>
            <div className="col">
              <Button
                variant="danger"
                className={StateForm?.loading ? ' btn-loading w-100' : 'w-100'}
                onClick={$handleDelete}
                disabled={StateForm?.loading}
              >
                Hapus
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      {/* modal send tms */}
      <Modal
        show={showTMS}
        onHide={$handleClose}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleClose} />
          <div className="modal-status bg-info" />
          <Fi.FiAlertTriangle className="mb-2 text-info" size={90} />
          <h3>Anda yakin?</h3>
          <p className="text-info fw-semibold">
            Anda yang pengiriman ini melalui Aplikasi TMS
          </p>
        </Modal.Body>
        <Modal.Footer>
          <div className="row w-100">
            <div className="col">
              <Button variant="white" className="w-100" onClick={$handleClose}>
                Batal
              </Button>
            </div>
            <div className="col">
              <Button
                variant="info"
                className={StateForm?.loading ? ' btn-loading w-100' : 'w-100'}
                onClick={$handleSendTMS}
                disabled={StateForm?.loading}
              >
                Ya
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Action;
